// extracted by mini-css-extract-plugin
export default {"importantInfo":"TCiZK","title":"N9QIp","content":"l55_O"};